import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import {
  ViewState,
  ValidateState,
  ToggleState
} from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { AnalyticsDisplay } from "./AnalyticsDisplay";
import { AnalyticsCard } from "./AnalyticsCard";

export class AnalyticsTable extends React.Component {
  state = {
    index: 0,
    showCard: false,
    selectedReport: ""
  };

  export = () => {
    this.dt.exportCSV();
  };

  getStationColumns = () => {
    console.log(this.props);
    var allColumns = [];
    // allColumns.push(
    //   <pr.Column
    //     key="expander"
    //     expander={true}
    //     style={{ width: "5em", float: "middle" }}
    //   />
    // );
    if (format.isNotNull(this.props.tableColumns)) {
      let columns = this.props.tableColumns.map((col, i) => {
        return (
          <pr.Column
            key={col.field}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            filter={col.filter}
            filterMatchMode={col.filterMatchMode}
            style={col.style}
          />
        );
      });

      columns.forEach(e => {
        allColumns.push(e);
      });
    }
    return allColumns;
  };

  updateState = (key, value) => {
    this.setState({ [key]: value });
  };
  render() {
    return this.state.showCard === true ? (
      <AnalyticsCard
        selectedReport={this.state.selectedReport}
        updateState={this.updateState}
      />
    ) : (
      <React.Fragment>
        <div className="ui-g-12">
          <pr.BreadCrumb
            model={this.props.menuState}
            home={pr.getBreadcrumbMenuHome()}
            style={{
              backgroundColor: "lightgrey",
              color: "black"
            }}
          />
        </div>
        <div className="ui-g-12">
          <div className="ui-g-12 ui-md-6 ui-lg-3">
            <div className="content-section">
              <div className="feature-intro">
                <h1>{"Analytics"}</h1>
                <p>{"A collection of analytics"}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="ui-g-12">
          <div className="ui-g-12 card">
            <pr.TabView
              activeIndex={this.state.index}
              onTabChange={e => {
                this.setState({ index: e.index });
              }}
            >
              <pr.TabPanel header="Standard">
                <div className="ui-g-12 ui-lg-4">
                  <h1>Operations Overview</h1>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Lead Time"
                        });
                      }}
                    >
                      <b>Lead Time</b>
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Manufacturing Cycle Time"
                        });
                      }}
                    >
                      <b>Manufacturing Cycle Time</b>
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Station/Process Cycle Time"
                        });
                      }}
                    >
                      <b>Station/Process Cycle Time</b>
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Takt-Time"
                        });
                      }}
                    >
                      Takt-Time
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Throughput"
                        });
                      }}
                    >
                      Throughput
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Queue Time"
                        });
                      }}
                    >
                      <b>Queue Time</b>
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Bar Chart per Product"
                        });
                      }}
                    >
                      Bar Chart per Product
                    </a>
                  </div>
                </div>
                <div className="ui-g-12 ui-lg-4">
                  <h1>Machines Overview</h1>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Machine Availability"
                        });
                      }}
                    >
                      Machine Availability
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Machine Performance"
                        });
                      }}
                    >
                      Machine Performance
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Quality"
                        });
                      }}
                    >
                      Quality
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "OEE"
                        });
                      }}
                    >
                      OEE
                    </a>
                  </div>
                </div>
                <div className="ui-g-12 ui-lg-4">
                  <h1>Workers Overview</h1>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Worker Productivity"
                        });
                      }}
                    >
                      Worker Productivity
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Worker Efficiency"
                        });
                      }}
                    >
                      Worker Efficiency
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Worker Performance"
                        });
                      }}
                    >
                      Worker Performance
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Worker Availability"
                        });
                      }}
                    >
                      Worker Availability
                    </a>
                  </div>
                  <div className="ui-g-12">
                    <a
                      href="#/analytics"
                      onClick={() => {
                        this.setState({
                          showCard: true,
                          selectedReport: "Stock Quantities"
                        });
                      }}
                    >
                      Stock Quantities
                    </a>
                  </div>
                </div>
              </pr.TabPanel>
            </pr.TabView>
          </div>
        </div>
      </React.Fragment>
    );
  }
  getDisplayCard = data => {
    return <AnalyticsDisplay data={data} onClick={this.props.crudlControl} />;
  };
}



// WEBPACK FOOTER //
// ./src/components/Analytics/UI/AnalyticsTable.js